import * as React from 'react';
import AutoLogoutLayout from '../common/Layout';
import { ForgotPasswordFlowForms } from '../../../core/enums';
import ForgotPasswordForm from './forms/ForgotPasswordForm';
import ForgotPasswordSuccessForm from './forms/ForgotPasswordSuccessForm';
import { loginPageUrl } from '../../../core/constants';
import Helmet from '../../../commonComponents/Helmet';
import { useNavigateWithAppName } from '../../common/NavigateWithAppName';

const ForgotPasswordPage = () => {
	const navigate = useNavigateWithAppName();
	const [activeForm, setActiveForm] = React.useState(ForgotPasswordFlowForms.ForgotPasswordForm);
	const [showForgotPasswordForm, setShowForgotPasswordForm] = React.useState(true);
	const [showForgotPasswordSuccessForm, setShowForgotPasswordSuccessForm] = React.useState(false);

	const showForm = (nextForm: ForgotPasswordFlowForms) => {
		setActiveForm(nextForm);
		setShowForgotPasswordForm(nextForm === ForgotPasswordFlowForms.ForgotPasswordForm);
		setShowForgotPasswordSuccessForm(nextForm === ForgotPasswordFlowForms.ForgotPasswordSuccessForm);
	};

	const handleSumit = () => {
		showForm(ForgotPasswordFlowForms.ForgotPasswordSuccessForm);
	};

	const handleBackButtonClick = () => {
		switch (activeForm) {
			case ForgotPasswordFlowForms.ForgotPasswordSuccessForm:
				setShowForgotPasswordSuccessForm(false);
				showForm(ForgotPasswordFlowForms.ForgotPasswordForm);
				break;
			default:
				navigate(loginPageUrl);
		}
	};

	return (
		<AutoLogoutLayout headerText="Forgot password" onBackButtonClick={handleBackButtonClick}>
			<Helmet>
				<title>Forgot password</title>
			</Helmet>
			{showForgotPasswordForm && <ForgotPasswordForm onSubmit={handleSumit} />}
			{showForgotPasswordSuccessForm && <ForgotPasswordSuccessForm />}
		</AutoLogoutLayout>
	);
};

export default ForgotPasswordPage;
